<template>
    <div class="body-pc" v-if="isMaintenance">
        <client-main></client-main>
        <client-footer></client-footer>
    </div>
    <div class="body-pc" v-else>
        <client-header></client-header>
        <client-main></client-main>
        <client-footer></client-footer>
    </div>
</template>
<script>
    import ClientHeader from '@/components/client/Header.vue'
    import ClientFooter from '@/components/client/Footer.vue'
    import ClientMain from '@/components/client/ClientMain.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'client',
        components: {
            'client-header': ClientHeader,
            'client-main': ClientMain,
            'client-footer': ClientFooter
        },
        computed: {
            ...mapGetters(['isMaintenance'])
        }
    }
</script>
